import { render } from "./PageTemplate.vue?vue&type=template&id=04a14238&scoped=true"
import script from "./PageTemplate.vue?vue&type=script&lang=ts"
export * from "./PageTemplate.vue?vue&type=script&lang=ts"

import "./PageTemplate.vue?vue&type=style&index=0&id=04a14238&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04a14238"

export default script